/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VendorErrorCategory } from './VendorErrorCategory';
import {
    VendorErrorCategoryFromJSON,
    VendorErrorCategoryFromJSONTyped,
    VendorErrorCategoryToJSON,
    VendorErrorCategoryToJSONTyped,
} from './VendorErrorCategory';
import type { VendorErrorParameter } from './VendorErrorParameter';
import {
    VendorErrorParameterFromJSON,
    VendorErrorParameterFromJSONTyped,
    VendorErrorParameterToJSON,
    VendorErrorParameterToJSONTyped,
} from './VendorErrorParameter';
import type { VendorErrorState } from './VendorErrorState';
import {
    VendorErrorStateFromJSON,
    VendorErrorStateFromJSONTyped,
    VendorErrorStateToJSON,
    VendorErrorStateToJSONTyped,
} from './VendorErrorState';
import type { VendorErrorImpactedComponent } from './VendorErrorImpactedComponent';
import {
    VendorErrorImpactedComponentFromJSON,
    VendorErrorImpactedComponentFromJSONTyped,
    VendorErrorImpactedComponentToJSON,
    VendorErrorImpactedComponentToJSONTyped,
} from './VendorErrorImpactedComponent';
import type { VendorErrorSeverity } from './VendorErrorSeverity';
import {
    VendorErrorSeverityFromJSON,
    VendorErrorSeverityFromJSONTyped,
    VendorErrorSeverityToJSON,
    VendorErrorSeverityToJSONTyped,
} from './VendorErrorSeverity';

/**
 * 
 * @export
 * @interface UpdateUnresolvedVendorErrorCodeRequestDto
 */
export interface UpdateUnresolvedVendorErrorCodeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    manufacturerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    assetTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    matchType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    matchKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    vendorErrorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    info?: string | null;
    /**
     * 
     * @type {VendorErrorParameter}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    parameter?: VendorErrorParameter | null;
    /**
     * 
     * @type {VendorErrorState}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    state?: VendorErrorState | null;
    /**
     * 
     * @type {VendorErrorImpactedComponent}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    impactedComponent?: VendorErrorImpactedComponent | null;
    /**
     * 
     * @type {VendorErrorCategory}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    category?: VendorErrorCategory | null;
    /**
     * 
     * @type {VendorErrorSeverity}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    severity?: VendorErrorSeverity | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    firmwareVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    sourceDescription?: string | null;
    /**
     * Audit remark for this update
     * @type {string}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    remark: string;
    /**
     * Optimistic concurrency version from the last read
     * @type {number}
     * @memberof UpdateUnresolvedVendorErrorCodeRequestDto
     */
    expectedVersion: number;
}



/**
 * Check if a given object implements the UpdateUnresolvedVendorErrorCodeRequestDto interface.
 */
export function instanceOfUpdateUnresolvedVendorErrorCodeRequestDto(value: object): value is UpdateUnresolvedVendorErrorCodeRequestDto {
    if (!('remark' in value) || value['remark'] === undefined) return false;
    if (!('expectedVersion' in value) || value['expectedVersion'] === undefined) return false;
    return true;
}

export function UpdateUnresolvedVendorErrorCodeRequestDtoFromJSON(json: any): UpdateUnresolvedVendorErrorCodeRequestDto {
    return UpdateUnresolvedVendorErrorCodeRequestDtoFromJSONTyped(json, false);
}

export function UpdateUnresolvedVendorErrorCodeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUnresolvedVendorErrorCodeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'assetTypeId': json['assetTypeId'] == null ? undefined : json['assetTypeId'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'matchKey': json['matchKey'] == null ? undefined : json['matchKey'],
        'vendorErrorCode': json['vendorErrorCode'] == null ? undefined : json['vendorErrorCode'],
        'info': json['info'] == null ? undefined : json['info'],
        'parameter': json['parameter'] == null ? undefined : VendorErrorParameterFromJSON(json['parameter']),
        'state': json['state'] == null ? undefined : VendorErrorStateFromJSON(json['state']),
        'impactedComponent': json['impactedComponent'] == null ? undefined : VendorErrorImpactedComponentFromJSON(json['impactedComponent']),
        'category': json['category'] == null ? undefined : VendorErrorCategoryFromJSON(json['category']),
        'severity': json['severity'] == null ? undefined : VendorErrorSeverityFromJSON(json['severity']),
        'firmwareVersion': json['firmwareVersion'] == null ? undefined : json['firmwareVersion'],
        'description': json['description'] == null ? undefined : json['description'],
        'sourceDescription': json['sourceDescription'] == null ? undefined : json['sourceDescription'],
        'remark': json['remark'],
        'expectedVersion': json['expectedVersion'],
    };
}

export function UpdateUnresolvedVendorErrorCodeRequestDtoToJSON(json: any): UpdateUnresolvedVendorErrorCodeRequestDto {
    return UpdateUnresolvedVendorErrorCodeRequestDtoToJSONTyped(json, false);
}

export function UpdateUnresolvedVendorErrorCodeRequestDtoToJSONTyped(value?: UpdateUnresolvedVendorErrorCodeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manufacturerId': value['manufacturerId'],
        'assetTypeId': value['assetTypeId'],
        'errorCode': value['errorCode'],
        'matchType': value['matchType'],
        'matchKey': value['matchKey'],
        'vendorErrorCode': value['vendorErrorCode'],
        'info': value['info'],
        'parameter': VendorErrorParameterToJSON(value['parameter']),
        'state': VendorErrorStateToJSON(value['state']),
        'impactedComponent': VendorErrorImpactedComponentToJSON(value['impactedComponent']),
        'category': VendorErrorCategoryToJSON(value['category']),
        'severity': VendorErrorSeverityToJSON(value['severity']),
        'firmwareVersion': value['firmwareVersion'],
        'description': value['description'],
        'sourceDescription': value['sourceDescription'],
        'remark': value['remark'],
        'expectedVersion': value['expectedVersion'],
    };
}

